import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import { Select, Colors, TextIcon } from 'advenio-components'
import { Form } from 'formsy-react'
import { AuthRedux } from 'auth-advenio'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'
import AllCentersActions from '../../Data/Redux/AllCentersRedux'
import Overview from './Overview'
import AttendanceReports from '../Reports/AttendanceReports'
import KidsReports from '../Reports/KidsReports'
import Dashboard from './index'
import FinancesReports from '../Reports/FinancesReports'
import RatingsReports from '../Reports/RatingsReports'
import IncidentsReports from '../Reports/IncidentsReports'
import LoadingSpinner from '../../Components/LoadingSpinner'
import EnrollmentReports from "../Reports/EnrollmentReports";
import DisenrollmentReports from "../Reports/DisenrollmentReports";
import MasterListReports from "../Reports/MasterListReports";
import ReceiptReports from "../Reports/ReceiptReports";
import UnvalidatedReceiptsReports from "../Reports/UnvalidatedReceiptsReports";

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: column;
`
const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
`
const Link = styled.span`
  color: ${Colors.blue500};
  cursor: pointer;
`
const Heading = styled.h1`
  margin-top: 8px;
  margin-bottom: 0;
  font-size: 32px;
`
const HeadingBar = styled(Form)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 16px 24px;
  box-sizing: border-box;
  border-bottom: 1px solid ${Colors.gray400};
`

const Views = {
  overview: { component: Overview },
  dashboard: { component: Dashboard },
  kids: { component: KidsReports },
  attendance: { component: AttendanceReports },
  finances: { component: FinancesReports },
  ratings: { component: RatingsReports },
  incidents: { component: IncidentsReports },
  enrollment: { component: EnrollmentReports },
  disenrollment: { component: DisenrollmentReports },
  masterlist: { component: MasterListReports },
  receipt: { component: ReceiptReports },
  unvalidatedReceipts: { component: UnvalidatedReceiptsReports },
}

const viewsObj = [
  {
    id: 0, label: 'Resumen', value: 'overview',
  },
  {
    id: 1, label: 'Niños', value: 'kids',
  },
  {
    id: 1, label: 'Asistencias', value: 'attendance',
  },
  {
    id: 2, label: 'Finanzas', value: 'finances',
  },
  {
    id: 3, label: 'Ratings', value: 'ratings',
  },
  {
    id: 4, label: 'Incidentes', value: 'incidents',
  },
  {
    id: 5, label: 'Altas', value: 'enrollment',
  },
  {
    id: 6, label: 'Bajas', value: 'disenrollment',
  },
  {
    id: 7, label: 'Lista Maestra', value: 'masterlist',
  },
  {
    id: 8, label: 'Cargos Sin Recibo', value: 'receipt',
  },
  {
    id: 9, label: 'Recibos Sin Validar', value: 'unvalidatedReceipts',
  },
]

class CentersInfo extends Component {
  state = {
    center: '',
    currentView: 'overview',
    views: viewsObj,
  }

  componentWillMount() {
    const { match, setCenter, getAllCenters } = this.props

    if (match.params) {
      this.setState({ currentView: match.params.view })
      setCenter(match.params.centerId)
      getAllCenters()
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.centers) {
      const center = nextProps.centers.find(c => c.id == nextProps.activeCenter)
      if (center) {
        this.setState({ center })
      }
    }
  }

  onChangeCallback = (event) => {
    const { goTo, activeCenter } = this.props
    const nextView = event.currentTarget.value
    this.setState({ currentView: nextView })
    goTo(`/centers/${activeCenter}/${nextView}`)
  }

  backToDashboard = () => this.props.goTo('/')

  goToImpersonate = () => {
    const { goTo, impersonateUserDirector } = this.props
    const data = {
      center_id: this.props.activeCenter,
    }
    impersonateUserDirector(data)
    localStorage.setItem('image_profile','')
    goTo('/')
  }

  render() {
    const { center, currentView, views } = this.state
    const CurrentView = Views[currentView]
    const currentViewObj = views.find(view => view.value == currentView)

    if (!center) {
      return <LoadingSpinner />
    }

    return (
      <Container>
        <HeadingBar>
          <HeadingContainer>
            <Link onClick={this.backToDashboard}>
              <TextIcon
                label="Ver todo Advenio"
                iconType="arrowRight"
                iconViewBox="-2 -3 24 24"
                iconColor={Colors.blue500}
                color={Colors.blue500}
                flipIconHorizontally
              />
            </Link>
            <Heading>{currentViewObj.label} – {center.name} ({center.abbreviation})</Heading>
          </HeadingContainer>
          <HeadingContainer>
            <Link onClick={this.goToImpersonate}>
              <TextIcon
                label="Visualizar este centro como la directora"
                iconType="arrowRight"
                iconViewBox="-2 -3 24 24"
                iconColor={Colors.blue500}
                color={Colors.blue500}
                RTL
              />
            </Link>
            <Select
              onChangeCallback={this.onChangeCallback}
              name="view"
              label="Seleccionar Vista"
              value={currentView}
              options={views}
              hideEmptyHelpBlock
            />
          </HeadingContainer>
        </HeadingBar>
        <CurrentView.component fromCenter />
      </Container>
    )
  }
}

CentersInfo.propTypes = {
  centers: PropTypes.array.isRequired,
  getAllCenters: PropTypes.func.isRequired,
  setCenter: PropTypes.func.isRequired,
  impersonateUserDirector: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
}

CentersInfo.defaultProps = {
}

const mapStateToProps = ({ centersInfo, allCenters }) => ({
  centersInfo: centersInfo.results,
  activeCenter: centersInfo.center,
  centers: allCenters.get.results,
})

const mapDispatchToProps = dispatch => ({
  getAllCenters: () => dispatch(AllCentersActions.getRequest()),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
  impersonateUserDirector: data => dispatch(AuthRedux.Actions.impersonateUserDirectorRequest(data)),
  goTo: link => dispatch(push(link)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CentersInfo)



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/CentersInfo.jsx